import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AuthenticationService } from './services/authentication/authentication.service';
import { BusinessEntityService } from './services/business-entity.service';
import { LookupService } from './services/lookup.service';
import { UserAccountStoreService } from './services/storage/user-account-store.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'utrack-web-spa-angular';
  userActivity: any;
  userInactive: Subject<any> = new Subject();
  isRoleChanged: boolean;
  
  constructor(public bService :BusinessEntityService, private readonly router: Router,private readonly userAccountStore: UserAccountStoreService,
    public lookupService: LookupService,private readonly authenticationService: AuthenticationService,){
      clearTimeout(this.userActivity);
        this.setTimeout();
        this.userInactive.subscribe(() => {
          localStorage.clear();
          sessionStorage.clear();
          this.authenticationService.logout()
        });

  }
 
  ngOnInit(): void {
    this.assignRoleDetails();
  }

  setEmployeeDetails(roleRank) {
    if(roleRank===4||roleRank===3||roleRank===7||roleRank===8){
      const localStorageAssumeUser = JSON.parse(localStorage.getItem('userAssumed'));
      if(localStorageAssumeUser !== undefined && localStorageAssumeUser !== null){
          if(localStorageAssumeUser.externalid === null || localStorageAssumeUser.rolerank=== 5|| localStorageAssumeUser.rolerank=== 1 || localStorageAssumeUser.rolerank=== 2 || localStorageAssumeUser.rolerank=== 6){
              localStorage.setItem("userAssumedData",'noData');
              this.lookupService.localStorageChanges('failure');
          } else{
              this.bService.loggedUserEmployeeId=localStorageAssumeUser.employeeids;
              this.bService.loggedUserName=localStorageAssumeUser.pdkusername;
              this.lookupService.localStorageChanges('success');
          }
      } else{
          this.lookupService.localStorageChanges('success');
      }
    } else{
      this.lookupService.localStorageChanges('failure');
    }
  }

  assignRoleDetails() {
    this.userAccountStore.userAccountDetails.subscribe(data => {
      if(data){
        if(data.account?.idTokenClaims?.roles[0]){
            this.bService.loggedUserGUID = data.account.idTokenClaims.ToyotaGUID;
            this.bService.loggedUserEmail = data.account.idTokenClaims.preferred_username;
            this.bService.userToken = data?.idToken;
            if(this.bService.loggedUserRole === undefined || this.bService.loggedUserRole === null){
                this.lookupService?.getUserInfo(data.account.idTokenClaims.ToyotaGUID).subscribe(data => {
                    
                    const roleRank=data.body[0].rolerank;
                    
                    this.bService.loggedUserRole = data.body[0].role;
                    sessionStorage.setItem('role',data.body[0].role)
                    this.bService.loggedUserName = `${data.body[0].firstname} ${data.body[0].lastname}`;
                    this.bService.loggedUserEmployeenameOriginal= `${data.body[0].firstname} ${data.body[0].lastname}`;
                    this.bService.loggedUserEmployeeId = data.body[0].employeeid;
                    this.bService.loggedUserEmployeeIdOriginal=data.body[0].employeeid;
                    this.bService.loggedUserBuyerCode = data.body[0].buyercode;
                    this.bService.loggedUserManagerCode = data.body[0].managercode;
                    this.bService.themeOwner=data.body[0].is_theme_owner;
                    this.bService.roleRank = roleRank;
                    sessionStorage.setItem("loginAssumeEmployeeid",data.body[0].employeeid);

                    this.setEmployeeDetails(roleRank);
                
                
                    
                
                })
            }else{
                const roleRank = this.bService.roleRank;
                this.setEmployeeDetails(roleRank);
            }
        }
      }
    })
  }

  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), 3600000) //3600000 = 60 min
  }
  
  @HostListener('document:keypress') refreshUserState2() {
    clearTimeout(this.userActivity);
    this.userActivity = 0;
    this.setTimeout();
  }
  
  @HostListener('document:click') refreshUserState3() { //NOSONAR
    clearTimeout(this.userActivity);
    this.userActivity = 0;
    this.setTimeout();
  }
  
  @HostListener('mousewheel') refreshUserState4() { //NOSONAR
    clearTimeout(this.userActivity);
    this.userActivity = 0;
    this.setTimeout();
  }
}
